var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1652753364045,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4403,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.805099 269.206999m44.340501-25.6l0 0q44.340501-25.6 69.940501 18.7405l51.2 88.681002q25.6 44.340501-18.740501 69.9405l0 0q-44.340501 25.6-69.940501-18.7405l-51.2-88.681002q-25.6-44.340501 18.740501-69.9405Z",
    fill: "#3ddc84",
    "p-id": 4404,
    "data-spm-anchor-id": "a313x.7781069.0.i5",
    className: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M871.874991 269.204022m-44.340501-25.6l0 0q-44.340501-25.6-69.9405 18.7405l-51.2 88.681002q-25.6 44.340501 18.7405 69.940501l0 0q44.340501 25.6 69.940501-18.740501l51.2-88.681002q25.6-44.340501-18.740501-69.9405Z",
    fill: "#3ddc84",
    "p-id": 4405,
    "data-spm-anchor-id": "a313x.7781069.0.i4",
    className: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.328 761.472c0.0768-0.896 0.1024-1.6384 0.1024-2.2528C51.4304 495.8336 289.2544 307.2 511.936 307.2c222.6944 0 460.6976 188.6336 460.6976 452.9664 0 0.5504 0.0256 1.1776 0.064 1.92A53.888 53.888 0 0 1 918.912 819.2H105.1008a53.888 53.888 0 0 1-53.76-57.728z",
    fill: "#3ddc84",
    "p-id": 4406,
    "data-spm-anchor-id": "a313x.7781069.0.i1",
    className: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M358.4 665.6m-51.2 0a51.2 51.2 0 1 0 102.4 0 51.2 51.2 0 1 0-102.4 0Z",
    fill: "#ffffff",
    "p-id": 4407,
    "data-spm-anchor-id": "a313x.7781069.0.i8",
    className: "selected"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M665.6 665.6m-51.2 0a51.2 51.2 0 1 0 102.4 0 51.2 51.2 0 1 0-102.4 0Z",
    fill: "#ffffff",
    "p-id": 4408,
    "data-spm-anchor-id": "a313x.7781069.0.i6",
    className: "selected"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApk);
export default __webpack_public_path__ + "static/media/apk.a9e18167b9c6fd83ef52086ce783bb02.svg";
export { ForwardRef as ReactComponent };